export default "/fonts/vendor/mdui/dist/roboto/Roboto-BlackItalic.woff?358ab56556eca0b75d021b4e938b830a";